import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var deleteFileRes;
export const deleteFileTodo = createAsyncThunk('deleteFile', async (id) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))

    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'library/delete_file',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "file_id": id,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return deleteFileRes = res.data
    } catch (error) {
        return deleteFileRes = error.response.data
    }
})